export default __webpack_public_path__ + "static/media/ras-al-khaimah-department-of-economic-development.ef021717.png";